import veryNegative from "../../../images/sentiment/veryNegative.svg"
import negative from "../../../images/sentiment/negative.svg"
import neutral from "../../../images/sentiment/neutral.svg"
import positive from "../../../images/sentiment/positive.svg"
import veryPositive from "../../../images/sentiment/veryPositive.svg"


/** Initial helper reference */
const helper = {}


export const sentiments = [
  {
    id: "veryPositive",
    icon: veryPositive
  },
  {
    id: "positive",
    icon: positive
  },

  {
    id: "neutral",
    icon: neutral
  },
  {
    id: "negative",
    icon: negative
  },
  {
    id: "veryNegative",
    icon: veryNegative
  }
]


/**
 *
 * Helper to run common requests
 * @param sentiment
 * @returns object
 */

helper.getSentimentById = (id) => sentiments.find((sentiment) => sentiment.id === id)

helper.getSentimentsList = sentiments.reverse()

helper.getSentimentsListWithCount = ({results = [], total}) => {
  return sentiments.map(({id, icon}) => {
    const findCount = results.find((result) => result.value === id) || {}
    const count = findCount.count || 0
    const percentage = count > 0 ? Math.round((count / total) * 100) : 0
    return {
      value: id,
      icon,
      count,
      percentage
    }
  })
}


/** export helpers individually */
export const getSentimentById = helper.getSentimentById

export const getSentimentsList = helper.getSentimentsList

export const getSentimentsListWithCount = helper.getSentimentsListWithCount

/** export default helper obj */
export default helper
